export const addressesTarget = {
  m: 0,
  p: 0,
  position: 'relative'
}

export const addressList = {
  position: 'relative',
  backgroundColor: 'white',
  maxHeight: 195,
  overflowY: 'scroll',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  border: ({ colors = {} }) => `2px solid ${colors.primary}`,
  height: 'auto',
  boxShadow: ({ colors = {} }) => `0 2px 3px 1px ${colors['shadow-black-05']}`
}

export const addressListItem = {
  fontSize: 'base',
  margin: 0,
  overflow: 'hidden',
  height: 'auto',
  lineHeight: '22px',
  width: '100%',
  '& > button': {
    p: 'base',
    appearance: 'none',
    outline: 'none',
    background: 'none',
    border: 0,
    width: '100%',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: 'grey-05',
      cursor: 'pointer'
    },
    '&:focus': {
      outlineOffset: '-2px',
      outline: '2px solid #FFAA55'
    }
  }
}

export const dropdownListItem = {
  ...addressListItem,
  p: 'base',
  pointerEvents: 'none'
}

export const addressesList = {
  p: 0,
  '& li': {
    ...addressListItem,
    borderBottom: ({ colors = {} }) => `1px solid ${colors['grey-20']}`,
    '&:last-of-type': {
      borderBottom: 'none'
    }
  }
}

export const addressesListWrapper = {
  ...addressList,
  position: 'unset',
  maxHeight: 335,
  '&[data-dropdown-loading]': {
    overflow: 'hidden'
  },
  '&[data-dropdown-loading] > .dropdown-loading': {
    display: 'block'
  }
}

export const addressSummary = {
  width: '80%;'
}

export const addressDropdownContainerBefore = {
  content: '""',
  display: 'block',
  width: 0,
  height: 3,
  borderRight: '14px solid transparent',
  borderBottom: ({ colors = {} }) => `14px solid ${colors.primary}`,
  borderLeft: '14px solid transparent',
  position: 'absolute',
  top: -14,
  left: 10
}

export const addressDropdownContainerAfter = {
  ...addressDropdownContainerBefore,
  borderRight: '12px solid transparent',
  borderBottom: ({ colors = {} }) => `12px solid ${colors.white}`,
  borderLeft: '12px solid transparent',
  top: -10,
  left: 12,
  height: 2
}

export const addressDropdownContainer = {
  position: 'absolute',
  zIndex: 3,
  width: '100%',
  height: 200,
  top: 4,
  '::before': {
    ...addressDropdownContainerBefore
  },
  '::after': {
    ...addressDropdownContainerAfter
  }
}

export const addressDropdownPosition = {
  position: 'relative'
}

export const underlayContainer = (addressUnderlay = false) => {
  return {
    '&:not(.element-hidden)': {
      '& .dropdown-underlay': {
        display: addressUnderlay ? 'block' : 'none'
      },
      '& .dropdown-underlay ~ .dropdown-underlay': {
        display: addressUnderlay ? 'block' : 'none'
      }
    }
  }
}

export const loader = {
  loader: { p: 0, position: 'relative' },
  text: { display: 'none' },
  spinner: { width: 26, height: 26, backgroundSize: 26 }
}

export const addressClickLoader = {
  loader: {
    p: 0,
    position: 'absolute',
    bottom: 0
  },
  spinner: {
    ...loader.spinner,
    position: 'absolute',
    top: 'calc(50% - 13px)',
    left: 'calc(50% - 13px)',
    m: 0
  },
  text: { display: 'none' }
}

export const addressSelectedLoading = {
  display: 'none',
  '& > div': {
    position: 'unset'
  },
  // The target here isn't exposed by Spark, so this is being used to select it.
  '& > div > div ~ div': {
    top: 2,
    left: 2,
    width: 'calc(100% - 4px)',
    height: 'calc(100% - 4px)'
  }
}

export const noPadding = {
  p: 0
}

export const noMargin = {
  m: 0
}

export const noPaddingNoMargin = {
  p: 0,
  m: 0
}

export const errorMessage = {
  ...addressSummary,
  p: 0,
  m: 0,
  width: '100%'
}

export const errorMessageTextBold = {
  display: 'inline-block',
  verticalAlign: 'top',
  width: 'calc(100% - 30px)',
  ml: 9
}

export const errorIcon = {
  display: 'inline-block',
  verticalAlign: 'top'
}
